import { waitForJob } from 'src/graphql/job';
import { ExtractionError } from 'src/lib/errors';

const JOB_POLLING_INTERVAL = 3000;

export const waitForExtraction = ({ id, options = null }) => {
  return waitForJob(id, {
    abortSignal: options?.abortSignal,
    pollingInterval: JOB_POLLING_INTERVAL,
  }).catch((error) => {
    throw new ExtractionError(error.message || 'Failed to extract', error.code);
  });
};
